<template>
  <component
    :is="tagName"
    :href="tag.url"
    class="tag"
    @click="$emit('clickTag')"
  >
    <span class="tag__label">
      {{ tag.name }}
    </span>
  </component>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export type ITag = {
    id: string | number;
    name: string;
    url: string;
  };

  export default defineNuxtComponent({
    name: 'Tag',

    props: {
      tag: {
        type: Object as PropType<ITag>,
        required: true,
      },
    },

    computed: {
      tagName(): string {
        return this.tag.url ? 'a' : 'span';
      },
    },
  });
</script>

<style lang="scss" scoped>
  .tag {
    text-decoration: none;
    padding: 6px;
    color: black;

    &__label {
      background-color: #f3f5fc;
      padding: 7px 12px;
      font-family: $mainFont;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      border-radius: 2px;
      position: relative;
      display: block;
      user-select: none;
      transition:
        background-color 0.3s ease,
        color 0.3s linear;

      &:focus-within {
        outline-color: #e59700;
        outline: 2px solid -webkit-focus-ring-color;
      }
    }

    @include hover {
      .tag__label {
        background-color: var(--bg-color-substrate-2);
        cursor: pointer;
      }
    }
  }
</style>
